const { BASE_URL } = require("./client");

const POST_FOUNDERS_CIRCLE_DATA = BASE_URL + "/api/founderscircleform";
const GET_FOUNDERS_CIRCLE_DATA = BASE_URL + "/api/founderscircleform";
const UPDATE_FOUNDERS_CIRCLE_DATA = BASE_URL + "/api/founderscircleform";
const DELETE_FOUNDERS_CIRCLE_DATA = BASE_URL + "/api/founderscircleform";

module.exports = {
  POST_FOUNDERS_CIRCLE_DATA,
  GET_FOUNDERS_CIRCLE_DATA,
  UPDATE_FOUNDERS_CIRCLE_DATA,
  DELETE_FOUNDERS_CIRCLE_DATA,
};
